(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/init.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  svs = svs || {};
  svs.statistics = svs.statistics || {};
  svs.statistics.common = svs.statistics.common || {};

  svs.statistics.common.getLeaguesIdKey = function (key) {
    return key >= 10000000 ? 'uniqueLeagueId' : 'id';
  };

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = svs.statistics.common;
  }
})();
 })(window);